module.exports = __webpack_public_path__ + "static/media/poster12.fd5db219.png";